import React from "react";
import Typography from "@material-ui/core/Typography";
const Item = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Item
      </Typography>
      <Typography paragraph variant="h5">
        Manage product master data to simplify stock opname
      </Typography>
      <Typography paragraph variant="body1">
        Item is one of the features under the Inventory module to manage item
        master data which is used for the selling or buying process during the
        company operation. It contains any information regarding the item
        specification, item categorization, item measurement, item variant, and
        basic pricing component of each item.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Item list. It is
        displayed like a table that contains download functions, sort, filter,
        and global search on the header area, and contains data navigation and
        refresh function on the footer area. The data column that appears in
        this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item ID</b>
        <br />
        Indicates the ID of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Type</b>
        <br />
        Indicates the type of the Item. There are 5 types including Finished
        Product, Service, Asset, Semi-Finished Product and Raw Material.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Code</b>
        <br />
        Indicates the code of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Name</b>
        <br />
        Indicates the full name of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Base Unit</b>
        <br />
        Indicates the base unit measurement of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Brand Name</b>
        <br />
        Indicates the brand name of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Item data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Item</b>
        <br />
        This button is used to edit the Item data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Detail</b>
        <br />
        This button is used to navigate to the Item detail and Item setup which
        contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Item data.
          </li>
          <li>
            <b>Price</b> : This tab is to setup the cost components as the basic
            price calculation during sales. This tab only appears for item type
            Finished Product, Semi-Finished Product and Raw Material.
          </li>
          <li>
            <b>Item Variants</b> : This tab is to setup any possible variants
            applied to the product. This tab only appears for item type Finished
            Product, Semi-Finished Product and Raw Material.
          </li>
          <li>
            <b>Alternative Units</b> : This tab is to setup another possible
            measurement for the product. This tab only appears for item type
            Finished Product, Semi-Finished Product and Raw Material.
          </li>
          <li>
            <b>Accounting</b> : This tab is to setup the general ledger account
            of each product if accounting wants to segregate the account by
            product.
          </li>
          <li>
            <b>Images</b> : This tab is to setup all product images.
          </li>
        </ul>
        When opening the Item detail, there will be 1 button appearing on the
        top section. The button is 'Edit Item' which is used to edit the Item
        data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Item</b>
        <br />
        This button is used to delete the Item data. The Item data is
        undeletable once it have transactions.
      </Typography>
    </React.Fragment>
  );
};

export default Item;
